/*@ngInject*/
const SubmissionMediator = function ($rootScope, $q, navigationRepository, activityStreamRepository, modificationsRepository, persistentConnection, submissionRepository, formUpgradeRepository, openSubmissionRepository, formUpgradeCheckRepository, currentSubmissionModel, registrationRepository, accountSubmissionsGridRepository, policiesSummaryGridRepository, coreMediator, detailedHistoryRepository) {

    this.loadSubmission = function (submissionId) {
        return persistentConnection.connect().then(function () {
            return openSubmissionRepository.openSubmission(submissionId);
        });
    };

    this.setSubmissionOpenHistory = function (submissionId) {
        return coreMediator.loadUserProfile().then(function (userProfile) {
            return submissionRepository.setSubmissionOpenHistory(submissionId, userProfile.userId);
        });
    };

    this.loadChangeSet = function (changeSetId) {
        return modificationsRepository.loadChangeSet(changeSetId);
    };

    this.createSubmission = function () {
        return submissionRepository.createSubmission();
    };

    this.submitSubmission = function (submissionId) {
        return submissionRepository.submitSubmission(submissionId);
    };

    this.deleteSubmission = function (submissionId) {
        return this.clearCurrentSubmissionRegistrations().finally(function () {
            return submissionRepository.deleteSubmission(submissionId).finally(function () {
                currentSubmissionModel.closeSubmission(submissionId);
            });
        });
    };

    this.closeSubmission = function (submissionId) {
        return this.clearCurrentSubmissionRegistrations().finally(function () {
            currentSubmissionModel.closeSubmission(submissionId);
            return submissionRepository.closeSubmission(submissionId);
        });
    };

    this.openSubmission = function (submissionId) {
        const deferred = $q.defer(),
            existingSubmission = currentSubmissionModel.getSubmissionById(submissionId);

        if (!existingSubmission) {
            openSubmissionRepository.openSubmission(submissionId).then(function (result) {
                currentSubmissionModel.openSubmission(result);
                deferred.resolve(result);
            });
        }

        return deferred.promise;
    };

    this.updateOpenSubmission = function (submission) {
        currentSubmissionModel.updateOpenSubmission(submission);
    };

    this.setSelectedSubmission = function (submission) {
        currentSubmissionModel.setSelectedSubmission(submission);
    };

    this.getSelectedSubmission = function () {
        return currentSubmissionModel.getSelectedSubmission();
    };

    this.setCurrentSubmission = function (submission) {
        return currentSubmissionModel.setCurrentSubmission(submission);
    };

    this.getCurrentSubmission = function () {
        return currentSubmissionModel.getCurrentNewSubmission() || currentSubmissionModel.getCurrentSubmission();
    };

    this.resetCurrentSubmission = function (submission) {
        return currentSubmissionModel.resetCurrentSubmission(submission);
    };

    this.getSubmissionById = function (submissionId) {
        return currentSubmissionModel.getSubmissionById(submissionId);
    };

    this.getOpenSubmissionList = function () {
        return currentSubmissionModel.getOpenSubmissionList();
    };

    this.resetOpenSubmissionList = function () {
        currentSubmissionModel.resetOpenSubmissionList();
    };

    this.clearCurrentSubmissionRegistrations = function () {
        const promises = [];
        _.each(currentSubmissionModel.getRegistrationsClone(), function (url) {
            promises.push(registrationRepository.deleteRegistration(url));
        });
        _.each(currentSubmissionModel.getActionsRegistrationsClone(), function (url) {
            promises.push(registrationRepository.deleteRegistration(url));
        });
        currentSubmissionModel.clearRegistrations();
        return $q.all(promises);
    };

    this.clearCurrentActionRegistrations = function () {
        const promises = [];
        _.each(currentSubmissionModel.getActionsRegistrationsClone(), function (url) {
            promises.push(registrationRepository.deleteRegistration(url));
        });
        currentSubmissionModel.clearActionsRegistrations();
        return $q.all(promises);
    };

    this.loadAccountSubmissions = function (accountId, accountNumber, submissionParams) {
        return accountSubmissionsGridRepository.loadSubmissions(accountId, accountNumber, submissionParams);
    };

    this.loadPolicies = function (submissionId, submissionParams) {
        return policiesSummaryGridRepository.loadPolicies(submissionId, submissionParams);
    };

    this.loadPoliciesBySubmissionIds = function (submissionIds, submissionParams) {
        return policiesSummaryGridRepository.loadPoliciesBySubmissionIds(submissionIds, submissionParams);
    };

    this.processPolicyChangeStatus = function (policyChange) {
        return policiesSummaryGridRepository.processGetResponseData([policyChange])[0];
    };

    this.getSubmissionNavItems = function (submissionId) {
        return navigationRepository.getNavigationItems(submissionId);
    };

    this.formNeedsUpgrade = function (submissionId) {
        return formUpgradeCheckRepository.submissionFormsNeedsUpgrade(submissionId);
    };

    this.upgradeForms = function (submissionId) {
        return formUpgradeRepository.upgradeSubmissionForms(submissionId);
    };

    this.loadActivityStreamItems = function (submissionId) {
        return activityStreamRepository.loadActivityStreamItems(submissionId);
    };

    this.getDetailedHistory = function (requestParams) {
        return detailedHistoryRepository.getDetailedHistory(requestParams);
    };

    this.deleteActionRegistrations = function (registrations) {
        const promises = [];
        _.each(registrations, function (registration) {
            currentSubmissionModel.removeActionsRegistration(registration.contextUri);
            promises.push(registrationRepository.deleteRegistration(registration.url));
        });
        return $q.all(promises);
    };

    this.updateSubmission = function (submissionId, submissionPropertiesMap) {
        return submissionRepository.updateSubmission(submissionId, submissionPropertiesMap);
    };

    this.getSubmissionTransactions = function (submissionId) {
        return submissionRepository.getSubmissionTransactions(submissionId);
    }

    this.isUserAuthorizedForSubmissionProduct = function (submissionId) {
        return submissionRepository.isUserAuthorizedForSubmissionProduct(submissionId);
    };
};

angular.module('gw-um-submission').service('submissionMediator', SubmissionMediator);
